import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { Post } from "../../lib/types"

export interface PostsState {
  items: Post[]
  status: "idle" | "loading" | "failed"
}

const initialState: PostsState = {
  items: [],
  status: "idle",
}

export const postsSlice = createSlice({
  name: "posts",
  initialState,
  reducers: {
    addPost: (state, action: PayloadAction<Post>) => {
      state.items.push(action.payload)
    },
    updatePost: (state, action: PayloadAction<Post>) => {
      const index = state.items.findIndex((p) => p.id === action.payload.id)
      if (index !== -1) {
        state.items[index] = action.payload
      }
    },
    deletePost: (state, action: PayloadAction<string>) => {
      state.items = state.items.filter((p) => p.id !== action.payload)
    },
    setPosts: (state, action: PayloadAction<Post[]>) => {
      state.items = action.payload
    },
  },
})

export const { addPost, updatePost, deletePost, setPosts } = postsSlice.actions
export default postsSlice.reducer
